<template>
  <!-- 左边菜单 -->
  <el-aside class="aside" :width="aside + 'px'">
    <Row style="height: 100%">
      <Col span="2">
      <Menu :theme="theme" style="width: 200px; height: 100%" :style="'background:' + LeftBackground" accordion>
        <MenuItem name="1" @click="routers('/setting/password')">
        <Icon type="ios-man" />
        修改密码
        </MenuItem>
        <MenuItem name="2" @click="routers('/setting/gaode')" v-if="$store.state.control == '1'">
        <Icon type="md-contacts" />
        高德地图配置
        </MenuItem>
        <MenuItem name="3" @click="routers('/setting/wxGzh')">
        <Icon type="logo-buffer" />
        微信公众号
        </MenuItem>
      </Menu>
      </Col>
    </Row>
  </el-aside>
  <!-- 内容 -->
  <el-main class="main">
    <router-view></router-view>
  </el-main>
</template>

<script>
export default {
  data() {
    return {
      value: true, //侧边栏
      aside: 200, //侧边栏宽度
      control: 0,
      theme: "",
      LeftBackground: "",
    };
  },
  computed: {
    asides() {
      return this.$store.state.switch;
    },
  },
  mounted() {
    // 获取主题
    this.theme = this.$store.state.theme;
    // 获取主题背景颜色
    this.LeftBackground = this.$store.state.LeftBackgroundColor;
  },
  watch: {
    // 监听侧边栏开关的值设置侧边栏宽度
    asides(newVal, oldVal) {
      if (newVal) {
        this.aside = 200;
      } else {
        this.aside = 45;
      }
    },
  },
  methods: {
    // 路由跳转
    routers(val) {
      this.sideOn(true);
      this.$router.push(val);
    },
    // 侧边栏开关
    sideOn(a) {
      if (a == null) {
        this.value = !this.value;
      } else {
        this.value = a;
      }
    },
  },
};
</script>

<style scoped>
@import url("//unpkg.com/element-ui@2.15.6/lib/theme-chalk/index.css");

.aside {
  /* background: #132c33; */
  background: white;
  transition: all 0.3s;
  border-top: 1px solid #111;
  z-index: 1000;
  overflow: hidden;
  padding: 0%;
}

.aside .menu {
  width: 200px;
  border-right: 0;
  padding-right: 0;
}

.aside .menu>.menu-v {
  border-right: 0;
}
</style>
